import {match} from 'ts-pattern';

import {FinancingRateMatrixCell, SaveSaleVehicleFinancingBody} from '@dms/api/vehicle';

import {ensureActiveFinancingCell} from './ensureActiveFinancingCell';

export function setActiveFinancingCell(
  body: SaveSaleVehicleFinancingBody,
  cell: FinancingRateMatrixCell,
  isActive: boolean
) {
  return match(isActive)
    .with(true, () => ({
      ...body,
      activeTerm: cell.term,
      activeDownPayment: cell.downPayment,
      activeBalloonPayment: cell.balloonPayment,
    }))
    .with(false, () => ensureActiveFinancingCell(body))
    .exhaustive();
}
